<template>
    <div class="translate-select" v-if="options.length > 0">
      <label
        v-if="showLabel"
        :class="['typo__label', { 'color-white': lightTheme, 'color-black': !lightTheme }]"
      >
        Language
      </label>
      <multiselect
        class="notranslate globe-image-before g-translate-select"
        :class="{ 'minimal-gt-dropdown': minimal, 'gt-dark': !lightTheme }"
        v-model="value"
        :options="options"
        :searchable="false"
        :close-on-select="true"
        :show-labels="false"
        :allow-empty="false"
        :hide-selected="true"
        track-by="code"
        label="name"
        @input="onChange"
        placeholder="Select a Language"
      />
    </div>
  </template>
  
  <script>
  import Multiselect from 'vue-multiselect';
  
  export default {
    name: 'LanguageSwitcher',
    components: {
      Multiselect,
    },
    props: {
      minimal: {
        type: Boolean,
        default: false,
      },
      lightTheme: {
        type: Boolean,
        default: true,
      },
      lang: {
        type: String,
        default: null,
      },
      showLabel: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        defaultLang: { name: 'English', code: 'en' },
        value: { name: 'English', code: 'en' },
        options: this.$router.currentRoute.fullPath.split('/')[1] !== 'assessment' && this.$router.currentRoute.fullPath.split('/')[1] !== 'management' ? [
          { name: 'English', code: 'en' },
          { name: 'Vietnamese', code: 'vi' },
          { name: 'Bahasa Indonesia', code: 'id' },
          { name: 'Hindi', code: 'hindi' },
          { name: 'Tamil', code: 'ta' },
          { name: 'Bengali', code: 'bengali' },
        ]:
         [
        ]
        ,
      };
    },
    methods: {
      onChange(selected) {
        localStorage.setItem('lang', selected.code);
        this.$i18n.locale = selected.code;
      },
      loadStoredLanguage() {
        const storedLang = localStorage.getItem('lang') || this.lang || this.defaultLang.code;
        localStorage.setItem('lang', storedLang);
        this.value = this.options.find((lang) => lang.code === storedLang) || this.defaultLang;
        this.$i18n.locale = this.value.code;
      },
    },
    mounted() {
      this.loadStoredLanguage();
      console.log(this.$router.currentRoute.fullPath.split('/')[1]);
    },
    watch: {
      lang(newLang) {
        this.value = this.options.find((lang) => lang.code === newLang) || this.defaultLang;
        this.$i18n.locale = this.value.code;
      },
    },
  };
  </script>
  
  <style scoped>
  .typo__label {
    background: transparent;
    border: none;
    font-size: 14px;
    font-family: 'Poppins', serif !important;
    padding-left: 20px;
    background: url('https://i.ibb.co/g9qSMhb/icons8-globe-50.png') no-repeat left center / 16px 16px;
  }
  .color-white {
    color: white;
  }
  .color-black {
    color: black;
  }
  </style>
  